import { render, staticRenderFns } from "./EditObject.vue?vue&type=template&id=796a28bc&scoped=true"
import script from "./EditObject.vue?vue&type=script&lang=js"
export * from "./EditObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a28bc",
  null
  
)

export default component.exports